import { useEffect, useState } from 'react'
import { Box, Fade, IconButton, Modal } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import { AppointmentProfile } from 'src/types'
import OfferingCardTop from 'src/pages/MUIBased/Appointments/components/OfferingCardTop'
import OfferingCardBottom from 'src/pages/MUIBased/Appointments/components/OfferingCardBottom'

interface OfferingModalProps {
    isOpen: boolean
    offering: AppointmentProfile | undefined
    onClose: () => void
}

const OfferingModal = ({ isOpen, offering, onClose }: OfferingModalProps) => {
    const [selectedOffering, setSelectedOffering] =
        useState<AppointmentProfile>()

    useEffect(() => {
        if (offering) {
            setSelectedOffering(offering)
        }
    }, [offering])

    return (
        <Modal open={isOpen} onClose={onClose}>
            <Fade in={isOpen}>
                <Box
                    sx={{
                        borderRadius: 1,
                        overflow: 'hidden',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: {
                            xs: '95%',
                            sm: '456px'
                        },
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        outline: 0
                    }}
                >
                    {!!selectedOffering && (
                        <>
                            <IconButton
                                onClick={onClose}
                                sx={{
                                    position: 'absolute',
                                    top: '12px',
                                    right: '12px'
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                            <OfferingCardTop offering={selectedOffering} />
                            <OfferingCardBottom offering={selectedOffering} />
                        </>
                    )}
                </Box>
            </Fade>
        </Modal>
    )
}

export default OfferingModal
